import { LocalizedString, localizedStringFromMap } from './LocalizedString';
import { ResearchStudy, researchStudyFromJson } from './ResearchStudy';

export interface BreathworkSupportingDocs {
  primaryBenefits: LocalizedString;
  studies: ResearchStudy[];
}

export function breathworkSupportingDocsFromJson(json: Record<string, unknown>): BreathworkSupportingDocs {
  return {
    primaryBenefits: localizedStringFromMap(json['primaryBenefits'] as Record<string, unknown>),
    studies: ((json['studies'] as Record<string, unknown>[]) ?? []).map(researchStudyFromJson),
  };
}
